const getConfig = () => {
  const APP_ID = process.env.VUE_APP_ID ?? "215"

  const config = {
    "21": {
      logo: {
        main: "/assets/21/logo/logo-dark.png",
        icon: "/assets/21/logo/icon.png",
        favicon: "/assets/21/logo/terminal.ico"
      },
      showLandingPage: false,
      realAccounts: {
        accountTypes: {
          stoic: {
            id: "6076c0d98bc7e600a265caf0",
            key: "stoic",
            name: "Stoic",
            specs: {
              minDeposit: "$50.000",
              spread: ["Spread RAW"],
              commission: "$7 Commission",
              swap: "Swap YES"
            }
          },
          thinker: {
            id: "6076c0d88bc7e600a265caed",
            key: "thinker",
            name: "Free Thinker",
            specs: {
              minDeposit: "$100",
              spread: [
                "Forex (Start from 14 point)",
                "XAU (Start from 38 point)",
                "XTI/Oil (Start from 30 point)"
              ],
              commission: "$10 Commission",
              swap: "Swap YES"
            }
          },
          advanced: {
            id: "6076c0d88bc7e600a265caef",
            key: "advanced",
            name: "Advanced Trader",
            specs: {
              minDeposit: "$1000",
              spread: [
                "Forex (Start from 10 point)",
                "XAU (Start from 30 point)",
                "XTI/Oil (Start from 25 point)"
              ],
              commission: "$5 Commission",
              swap: "Swap YES"
            }
          }
        },
        leverageOptions: [
          { value: "10", label: "1:10" },
          { value: "50", label: "1:50" },
          { value: "100", label: "1:100" },
          { value: "200", label: "1:200" },
          { value: "500", label: "1:500" }
        ],
        ui: {
          title: {
            indo: "Buat Akun Trading Baru",
            uk: "Create New Trading Account"
          },
          description: {
            indo: "Membuat akun Trading Asli Baru. Pilih akun di bawah ini!",
            uk: "Creating new real trading account. Choose account below!"
          },
          specification: {
            indo: "Spesifikasi",
            uk: "Specification"
          },
          chooseCard: {
            indo: "Silahkan pilih salah satu kartu.",
            uk: "Please choose a card."
          },
          selectOption: {
            indo: "Pilih Opsi Akun",
            uk: "Select your option"
          },
          createButton: {
            indo: "Buat Akun",
            uk: "Create Account"
          },
          selectLeverage: {
            indo: "Pilih leverage",
            uk: "Select leverage"
          },
          selectAccountType: {
            indo: "Pilih tipe akun",
            uk: "Select account type"
          }
        }
      },
      demoAccounts: {
        accountTypes: {
          demo: {
            id: "6076c0d78bc7e600a265caea",
            key: "demo",
            name: {
              indo: "Akun Demo",
              uk: "Demo Account"
            },
            specs: {
              spread: "Spread under 10",
              commission: "Commission start from $10",
              leverage: "Up to 500 Leverage"
            }
          }
        },
        leverageOptions: [
          { value: "10", label: "1:10" },
          { value: "50", label: "1:50" },
          { value: "100", label: "1:100" },
          { value: "200", label: "1:200" },
          { value: "500", label: "1:500" }
        ],
        ui: {
          title: {
            indo: "Buat Akun Trading Demo",
            uk: "Create Demo Trading Account"
          },
          description: {
            indo: "Membuat akun Trading Demo Baru. Pilih akun di bawah ini!",
            uk: "Creating new demo trading account. Choose account below!"
          },
          specification: {
            indo: "Spesifikasi",
            uk: "Specs"
          },
          chooseCard: {
            indo: "Silahkan pilih salah satu kartu.",
            uk: "Please choose a card."
          },
          leverage: "Leverage",
          deposit: "Deposit (Optional)",
          createButton: {
            indo: "Buat Akun",
            uk: "Create Account"
          }
        },
        features: {
          depositInput: true,
          singleCardDisplay: true
        }
      },
      crypto: {
        supportedNetworks: ["TRC20","ERC20"],
        addresses: {
          trc20: "TRNhuFS9wZKHandY1Dv3JRT5FzkVb8dPhu",
          erc20: "0x7A85A6334DBBA3bCD021630a47f6BDbB3468B882",
        },
        qrImages: {
          trc20: "/assets/21/TRC20.png",
          erc20: "/assets/21/ERC20.png",
        }
      },
      deposit: {
        charge: {
          enabled: true,
          value: [
            { amount_max: 25000, percent: 1.5 },
            { amount_max: 50000, percent: 1 },
            { amount_max: Infinity, percent: 0.8 }
          ]
        },
        disclaimer: {
          show: true,
          html: `
            <h5><b>Important note on deposit fees:</b></h5>
            There is a charge if you do the deposit via USDT wallet as you see on your request deposit,
            <ul style="margin: 0 0 0 0px;">
            <li>1.5% charge if you deposit under $25,000 USDT</li>
            <li>1% charge if you deposit between $25,000 - $50,000 USDT</li>
            <li>0.8% charge if you deposit more than $50,000 USDT</li>
            </ul>
            <div style="margin-top: 10px;">
              <b>Examples:</b>
              <ul style="margin: 5px 0 0 20px;">
                <li>Deposit $1,000 → Transfer $1,015.06 (1.5% fee = $15 + unique code)</li>
                <li>Deposit $25,000 → Transfer $25,250.02 (1% fee = $250 + unique code)</li>
                <li>Deposit $50,000 → Transfer $50,400.0.7 (0.8% fee = $400 + unique code)</li>
              </ul>
            </div>
          `
        },
        unique_code_disclaimer: {
          show: true,
          html: `
            <span style="color: #ffcc00; font-size: 18px; vertical-align: middle; margin-right: 6px;">&#9888;&#65039;</span>
            The unique <b>code</b> is added to your deposit amount for faster verification. It is <b>Not</b> part of your deposit balance.
          `
        }
      }
    },
    "215": {
      logo: {
        main: "/assets/21/logo/logo-dark.png",
        icon: "/assets/21/logo/icon.png",
        favicon: "/assets/21/logo/terminal.ico"
      },
      showLandingPage: true,
      realAccounts: {
        accountTypes: {
          hedge: {
            id: "6863459154822f9817621d6b",
            key: "hedge",
            name: "Hedging Account",
            specs: {
              minDeposit: "$1000",
              spread: ["Spread RAW"],
              commission: "$7 Commission",
              swap: ""
            }
          }
        },
        leverageOptions: [
          { value: "10", label: "1:10" },
          { value: "25", label: "1:25" },
        ],
        ui: {
          title: {
            indo: "Buat Akun Trading Baru",
            uk: "Create New Trading Account"
          },
          description: {
            indo: "Membuat akun Trading Asli Baru. Pilih akun di bawah ini!",
            uk: "Creating new real trading account. Choose account below!"
          },
          specification: {
            indo: "Spesifikasi",
            uk: "Specification"
          },
          chooseCard: {
            indo: "Silahkan pilih salah satu kartu.",
            uk: "Please choose a card."
          },
          selectOption: {
            indo: "Pilih Opsi Akun",
            uk: "Select your option"
          },
          createButton: {
            indo: "Buat Akun",
            uk: "Create Account"
          },
          selectLeverage: {
            indo: "Pilih leverage",
            uk: "Select leverage"
          },
          selectAccountType: {
            indo: "Pilih tipe akun",
            uk: "Select account type"
          }
        }
      },
      demoAccounts: {
        accountTypes: {
          demo: {
            id: "68636c6654822f9817621f72",
            key: "demo",
            name: {
              indo: "Akun Demo",
              uk: "Demo Account"
            },
            specs: {
              spread: "Spread under 10",
              commission: "Commission start from $10",
              leverage: "Up to 500 Leverage"
            }
          }
        },
        leverageOptions: [
          { value: "10", label: "1:10" },
          { value: "50", label: "1:50" },
        ],
        ui: {
          title: {
            indo: "Buat Akun Trading Demo",
            uk: "Create Demo Trading Account"
          },
          description: {
            indo: "Membuat akun Trading Demo Baru. Pilih akun di bawah ini!",
            uk: "Creating new demo trading account. Choose account below!"
          },
          specification: {
            indo: "Spesifikasi",
            uk: "Specs"
          },
          chooseCard: {
            indo: "Silahkan pilih salah satu kartu.",
            uk: "Please choose a card."
          },
          leverage: "Leverage",
          deposit: "Deposit (Optional)",
          createButton: {
            indo: "Buat Akun",
            uk: "Create Account"
          }
        },
        features: {
          depositInput: true,
          singleCardDisplay: true
        }
      },
      crypto: {
        supportedNetworks: ["TRC20","ERC20", "BEP20"],
        addresses: {
          trc20: "TGtr6aaUsJRFzeoSnzegdJfGLuMDeA2jCy",
          erc20: "0xF992Bbab78AeE3dA8F85D8c8b783846820455DbF",
          bep20: "0xF992Bbab78AeE3dA8F85D8c8b783846820455DbF",
        },
        qrImages: {
          trc20: "/assets/215/TRC20.jpg",
          erc20: "/assets/215/ERC20.png",
          bep20: "/assets/215/BEP20.jpg",
        }
      },
      deposit: {
        charge: {
          enabled: false,
          value: []
        },
        disclaimer: {
          show: false,
          html: ``
        },
        unique_code_disclaimer: {
          show: false,
          html: ``
        }
      }
    }
  }

  return config[APP_ID] || config["215"]
}

export const AppConstants = getConfig()

// Language constants
export const Languages = {
  INDO: 'indo',
  UK: 'uk'
}

// Account type constants
export const AccountTypes = {
  REAL: 'REAL',
  DEMO: 'DEMO'
}

// API configuration
export const ApiConfig = {
  url: process.env.VUE_APP_API_URL,
  token: process.env.VUE_APP_API_TOKEN
}

// Success/Error messages
export const Messages = {
  success: {
    indo: {
      title: "Berhasil",
      text: "Anda Berhasil membuat akun."
    },
    uk: {
      title: "Succeed",
      text: "You have successfully created an account."
    }
  },
  error: {
    serviceUnavailable: {
      indo: "Layanan Belum Tersedia",
      uk: "Service Not Available"
    }
  }
}

// Common UI text
export const CommonUI = {
  accountInfo: {
    title: {
      indo: "Informasi Akun Trading",
      uk: "Trading Account Information"
    },
    name: {
      indo: "Nama",
      uk: "Name"
    },
    email: {
      indo: "Email",
      uk: "Email"
    },
    type: {
      indo: "Tipe",
      uk: "Type"
    },
    role: {
      indo: "Posisi",
      uk: "Role"
    }
  }
}

// Signup UI text
export const SignupUI = {
  title: "Only one step! Join with us and enjoy the benefit.",
  form: {
    fullName: "Enter full name",
    email: "Enter your email",
    referral: "Referral code",
    password: "Your password",
    confirmPassword: "Confirm password",
    selectLeverage: "Select leverage",
    selectAccountType: "Select account type",
    terms: "I Have read & agree Terms and Condition",
    register: "Register"
  },
  links: {
    haveAccount: {
      indo: "Sudah punya akun?",
      uk: "Have an account?"
    },
    login: "Login"
  },
  messages: {
    passwordMismatch: "Please make sure your password and confirm password is match!",
    registrationSuccess: {
      title: "Congratulations!",
      text: "Your registration has been submitted successfully! Please check your email to verify your account."
    }
  }
}